var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolidChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_13709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8542 12.9583H1.3125V1.58333C1.3125 1.50312 1.24687 1.4375 1.16667 1.4375H0.145833C0.065625 1.4375 0 1.50312 0 1.58333V14.125C0 14.2052 0.065625 14.2708 0.145833 14.2708H13.8542C13.9344 14.2708 14 14.2052 14 14.125V13.1042C14 13.024 13.9344 12.9583 13.8542 12.9583ZM3.24115 10.1456C3.29766 10.2021 3.3888 10.2021 3.44714 10.1456L5.96823 7.63724L8.29427 9.97786C8.35078 10.0344 8.44375 10.0344 8.50026 9.97786L13.5206 4.95938C13.5771 4.90286 13.5771 4.8099 13.5206 4.75339L12.7987 4.03151C12.7713 4.00437 12.7343 3.98915 12.6957 3.98915C12.6571 3.98915 12.6201 4.00437 12.5927 4.03151L8.4 8.2224L6.0776 5.88542C6.05019 5.85828 6.01318 5.84305 5.97461 5.84305C5.93604 5.84305 5.89902 5.85828 5.87161 5.88542L2.52109 9.21589C2.49395 9.24329 2.47873 9.28031 2.47873 9.31888C2.47873 9.35745 2.49395 9.39447 2.52109 9.42187L3.24115 10.1456Z",
    fill: "#AEB5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_13709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidChart);
export default __webpack_public_path__ + "static/media/icon-solid-chart.2bf94bc6.svg";
export { ForwardRef as ReactComponent };